import { Box, Fab, Collapse, Grid, styled, Table, TableBody, TableContainer, TableHead, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { monthsOption } from '../../utils';
import IconBackground from '../Common/IconBackground';
import { BUCKET_URL } from '../../ApiSetUp/AuthApi';
import { standardDateFormat } from '../../lib/standardDateFormat';
import CommonPagination from '../Common/CommonPagination';
import StyledTableRow from '../Common/StyledTableRow';
import StyledTableCell from '../Common/StyledTableCell';
import NoDataFound from '../Common/NoDataFound';
import { getPurchaseEntryItems } from "../../Redux/Actions/PurchaseEntry";
import { useEffect } from 'react';
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { getInvoiceItemById } from "../../Redux/Actions/Invoice";

const KeyName = styled('div')(({ theme }) => ({
    fontSize: '16px',
    fontFamily: 'Satoshi-Light',
}));

const Answer = styled('div')(({ theme }) => ({
    fontSize: '16px',
    fontFamily: 'Satoshi-Bold',
}));

const ViewDocument = ({ activeTab, selectedItem, poDocumentByLicenseData, _getPoDocumentsByAdvanceLicense }) => {
    // ============== Hooks ==============
    const theme = useTheme();

    // ============== States ==============
    const [page, setPage] = useState(1);
    let PerPage = 5

    // ============== Handler ==============
    const handleChangePage = (e, p) => {
        setPage(p);
    };


    // ============== Use Effect ==============
    useEffect(() => {
        _getPoDocumentsByAdvanceLicense(selectedItem?.advanceLicenseNo, page, PerPage)
    }, [page])


    // console.log(selectedItem, "selectedItem")
    // ============= export and import table data api =========//
    const dispatch = useDispatch()
    const [importData, setImportData] = useState([])
    const [ipage, setIPage] = useState(1);
    const [itotalCount, setITotalCount] = useState(1);
    const [etotalCount, seteTotalCount] = useState(1);
    const [exportData, setExportData] = useState([])
    const [epage, setEPage] = useState(1);
    const [openRow, setOpenRow] = useState(null);
    const [subData, setSubData] = useState([]);
    const [subPage, setSubPage] = useState(1);

    let SubPerPage = 5;
    const handleChangeSubPage = (event, newPage) => {
        setSubPage(newPage);
    };
    const paginatedSubData = subData.slice(
        (subPage - 1) * SubPerPage,
        subPage * SubPerPage
    );

    const handleChangeEPage = (e, p) => {
        setEPage(p);
    };

    const handleChangeIPage = (e, p) => {
        setIPage(p);
    };

    const _getPurchaseEntryItems = async (body) => {
        const res = await dispatch(getPurchaseEntryItems(body))
        // console.log(res.payload.data)
        setImportData(res?.payload?.data?.response);
        setITotalCount(res?.payload?.data?.totalCount)
    }

    const _getSubData = (index) => {
        setSubData(importData[index].advanceLicenseItems)
    }

    // console.log(subData, "subData")
    // console.log(openRow, "openRow")

    useEffect(() => {
        const body = { advanceLicenseId: selectedItem._id, page: ipage, PerPage }
        _getPurchaseEntryItems(body)
    }, [ipage])

    const _getExportData = async () => {
        const body = { id: selectedItem._id, page: epage, limit: PerPage }
        const res = await dispatch(getInvoiceItemById(body))
        setExportData(res?.payload?.data?.response);
        seteTotalCount(res?.payload?.data?.pagination?.totalRecords);
    }

    useEffect(() => {
        _getExportData()
    }, [epage])

    return (
        <Grid container padding={"30px"} spacing={3} >
            {[5].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Receipt Number</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.reciptNumber || "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[0, 2, 4, 5, 6, 7, 8, 9, 10].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Year</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.year || "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[0, 2, 4, 5, 6, 7, 8, 9, 10].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Month</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.month ? monthsOption?.find((ele) => selectedItem?.month == ele?.id)?.name : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[0].includes(activeTab?.value) &&
                selectedItem?.light_bill?.length > 0 &&
                selectedItem?.light_bill?.map((ele, i) => {
                    return (
                        <Grid container item xs={12}>
                            <Grid item xs={12}>
                                <KeyName>{`Location ${i + 1}`}</KeyName>
                            </Grid>
                            <Grid item xs={3}>
                                <KeyName>Units</KeyName>
                            </Grid>
                            <Grid item xs={1} textAlign={"center"}>
                                <Answer>:</Answer>
                            </Grid>
                            <Grid item xs={8}>
                                <Answer>{ele?.month ? monthsOption?.find((ele) => ele?.month == ele?.id)?.name : "NA"}</Answer>
                            </Grid>
                            <Grid item xs={3}>
                                <KeyName>Amount</KeyName>
                            </Grid>
                            <Grid item xs={1} textAlign={"center"}>
                                <Answer>:</Answer>
                            </Grid>
                            <Grid item xs={8}>
                                <Answer>{ele?.amount || "NA"}</Answer>
                            </Grid>
                            <Grid item xs={3}>
                                <KeyName>Location</KeyName>
                            </Grid>
                            <Grid item xs={1} textAlign={"center"}>
                                <Answer>:</Answer>
                            </Grid>
                            <Grid item xs={8}>
                                <Answer>{ele?.location_name || "NA"}</Answer>
                            </Grid>
                            <Grid item xs={3}>
                                <KeyName>Document</KeyName>
                            </Grid>
                            <Grid item xs={1} textAlign={"center"}>
                                <Answer>:</Answer>
                            </Grid>
                            <Grid item xs={8}>
                                {ele?.document ?
                                    <Box display="flex" flexWrap={"wrap"} alignItems={"center"} gap={1}>
                                        <Answer>{ele?.document?.split("/").pop()}</Answer>
                                        <IconBackground icon="visibility" size='34px' onClick={() => window?.open(`${BUCKET_URL + ele?.document}`)} />
                                    </Box>
                                    : <Answer>NA</Answer>
                                }
                            </Grid>
                        </Grid>
                    )
                })
            }
            {[1].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Document Name</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.documentName || "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[1].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Expiry Date</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.expiryDate ? standardDateFormat(selectedItem?.expiryDate) : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[1, 2].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Document</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        {selectedItem?.document ?
                            <Box display="flex" flexWrap={"wrap"} alignItems={"center"} gap={1}>
                                <Answer>{selectedItem?.document?.split("/").pop()}</Answer>
                                <IconBackground icon="visibility" size='34px' onClick={() => window?.open(`${BUCKET_URL + selectedItem?.document}`)} />
                            </Box>
                            : <Answer>NA</Answer>
                        }
                    </Grid>
                </Grid>
            }
            {[3].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Start Date</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.startDate ? standardDateFormat(selectedItem?.startDate) : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[3].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>End Date</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.endDate ? standardDateFormat(selectedItem?.endDate) : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[3, 5, 7, 8].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Amount</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.amount_1 ? selectedItem?.amount_1 : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[3].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Assured Amount</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.amount_2 ? selectedItem?.amount_2 : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[3].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Purpose</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.purpose ? selectedItem?.purpose : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[3].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Company Name</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.companyName ? selectedItem?.companyName : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[3].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Location</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.location ? selectedItem?.location : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[3, 4, 10].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Document</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        {selectedItem?.document ?
                            <Box display="flex" flexWrap={"wrap"} alignItems={"center"} gap={1}>
                                <Answer>{selectedItem?.document?.split("/").pop()}</Answer>
                                <IconBackground icon="visibility" size='34px' onClick={() => window?.open(`${BUCKET_URL + selectedItem?.document}`)} />
                            </Box>
                            : <Answer>NA</Answer>
                        }
                    </Grid>
                </Grid>
            }
            {[5].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Challan Document</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        {selectedItem?.challanDocument ?
                            <Box display="flex" flexWrap={"wrap"} alignItems={"center"} gap={1}>
                                <Answer>{selectedItem?.challanDocument?.split("/").pop()}</Answer>
                                <IconBackground icon="visibility" size='34px' onClick={() => window?.open(`${BUCKET_URL + selectedItem?.challanDocument}`)} />
                            </Box>
                            : <Answer>NA</Answer>
                        }
                    </Grid>
                </Grid>
            }
            {[5].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Receipt Document</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        {selectedItem?.recieptDocument ?
                            <Box display="flex" flexWrap={"wrap"} alignItems={"center"} gap={1}>
                                <Answer>{selectedItem?.recieptDocument?.split("/").pop()}</Answer>
                                <IconBackground icon="visibility" size='34px' onClick={() => window?.open(`${BUCKET_URL + selectedItem?.recieptDocument}`)} />
                            </Box>
                            : <Answer>NA</Answer>
                        }
                    </Grid>
                </Grid>
            }
            {[5].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Form 1 Document</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        {selectedItem?.form_1_Document ?
                            <Box display="flex" flexWrap={"wrap"} alignItems={"center"} gap={1}>
                                <Answer>{selectedItem?.form_1_Document?.split("/").pop()}</Answer>
                                <IconBackground icon="visibility" size='34px' onClick={() => window?.open(`${BUCKET_URL + selectedItem?.form_1_Document}`)} />
                            </Box>
                            : <Answer>NA</Answer>
                        }
                    </Grid>
                </Grid>
            }
            {[6].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>S1</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.salary_1 ? selectedItem?.salary_1 : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[6].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>S2</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.salary_2 ? selectedItem?.salary_2 : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[6].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>S3</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.salary_3 ? selectedItem?.salary_3 : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[6].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>S4</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.salary_4 ? selectedItem?.salary_4 : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[6].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>S5</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.salary_5 ? selectedItem?.salary_5 : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[7].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Bank Chrges</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.bankCharge ? selectedItem?.bankCharge : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[8].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Quantity</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.quantity ? selectedItem?.quantity : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[9].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>C1 (Kg)</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.c1_kg ? selectedItem?.c1_kg : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[9].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>C2 (Kg)</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.c2_kg ? selectedItem?.c2_kg : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[9].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>C3 (Kg)</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.c3_kg ? selectedItem?.c3_kg : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[9].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>C4 (Kg)</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.c4_kg ? selectedItem?.c4_kg : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[9].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>C5 (Kg)</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.c5_kg ? selectedItem?.c5_kg : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[9].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>C6 (Kg)</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.c6_kg ? selectedItem?.c6_kg : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[9].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>C1 (Sqmt)</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.c1_sqmt ? selectedItem?.c1_sqmt : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[9].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>C2 (Sqmt)</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.c2_sqmt ? selectedItem?.c2_sqmt : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[9].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>C3 (Sqmt)</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.c3_sqmt ? selectedItem?.c3_sqmt : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[9].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>C4 (Sqmt)</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.c4_sqmt ? selectedItem?.c4_sqmt : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[9].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>C5 (Sqmt)</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.c5_sqmt ? selectedItem?.c5_sqmt : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[9].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>C6 (Sqmt)</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.c6_sqmt ? selectedItem?.c6_sqmt : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[12].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Advance License Number</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.advanceLicenseNo ? selectedItem?.advanceLicenseNo : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[12].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Advance License Date</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.advanceLicenseDate ? standardDateFormat(selectedItem?.advanceLicenseDate) : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[12].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Advance License Quantity</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.advanceLicenseQty ? selectedItem?.advanceLicenseQty : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[12].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Export Quantity</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.exportQty ? selectedItem?.exportQty : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[12].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Import Quantity</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.importQty ? selectedItem?.importQty : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {/* {[12].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>FOB Value</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.fobValue ? selectedItem?.fobValue : "NA"}</Answer>
                    </Grid>
                </Grid>
            } */}
            {[12].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Export Value</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.exportValue ? selectedItem?.exportValue : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {/* {[12].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>CIF Value</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.cifValue ? selectedItem?.cifValue : "NA"}</Answer>
                    </Grid>
                </Grid>
            } */}
            {[12].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Import Value</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.importValue ? selectedItem?.importValue : "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {[12].includes(activeTab?.value) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Document</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        {selectedItem?.document ?
                            <Box display="flex" flexWrap={"wrap"} alignItems={"center"} gap={1}>
                                <Answer>{selectedItem?.document?.split("/").pop()}</Answer>
                                <IconBackground icon="visibility" size='34px' onClick={() => window?.open(`${BUCKET_URL + selectedItem?.document}`)} />
                            </Box>
                            : <Answer>NA</Answer>
                        }
                    </Grid>
                </Grid>
            }
            {[12].includes(activeTab?.value) &&
                <Grid item xs={12}>
                      <Typography sx={{fontSize:18, paddingLeft:2, fontWeight:"bold", marginBottom:1}}>Export Details:</Typography>
                    <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                        <TableContainer>
                            <Table sx={{ borderBottom: '1px solid #c8d3d96e' }}>
                                <TableHead>
                                    <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                                        <StyledTableCell>SR.</StyledTableCell>
                                        <StyledTableCell>
                                            <Typography fontFamily={"Satoshi-Bold"} width={"100px"} whiteSpace={"wrap"}>
                                                Invoice Number
                                            </Typography>
                                        </StyledTableCell>
                                        <StyledTableCell>Invoice Date</StyledTableCell>
                                        <StyledTableCell>Customer Name</StyledTableCell>
                                        <StyledTableCell>Amount</StyledTableCell>
                                        <StyledTableCell>Quantity</StyledTableCell>
                                        <StyledTableCell>Action</StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {exportData?.length > 0 ?
                                        exportData?.map((row, index) => {
                                            return (
                                                <React.Fragment key={index}>
                                                    <StyledTableRow>
                                                        <StyledTableCell> {index + 1 + (page - 1) * PerPage}</StyledTableCell>
                                                        <StyledTableCell> {row?.invoiceNumber ? row?.invoiceNumber : "NA"}</StyledTableCell>
                                                        <StyledTableCell> {row?.invoiceDate ? new Date(row.invoiceDate).toLocaleDateString() : ""}</StyledTableCell>
                                                        <StyledTableCell> {row?.customer_name ? row?.customer_name : "NA"}</StyledTableCell>
                                                        <StyledTableCell> {row?.totalAmount ? row?.totalAmount : "0"}</StyledTableCell>
                                                        <StyledTableCell> {row?.totalQuantity ? row?.totalQuantity : "0"}</StyledTableCell>
                                                    </StyledTableRow>
                                                </React.Fragment>
                                            )
                                        })
                                        :
                                        <StyledTableRow>
                                            <StyledTableCell colSpan={12}>
                                                <NoDataFound />
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <CommonPagination
                            totalCount={etotalCount}
                            count={Math.ceil(etotalCount / PerPage)}
                            itemsPerPage={PerPage}
                            page={epage}
                            onChange={handleChangeEPage}
                        />
                    </Box>
                </Grid>
            }
            {[12].includes(activeTab?.value) &&
                <Grid item xs={12}>
                     <Typography sx={{fontSize:18, paddingLeft:2, fontWeight:"bold", marginBottom:1}}>Import Details:</Typography>
                    <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                         
                        <TableContainer>
                            <Table sx={{ borderBottom: '1px solid #c8d3d96e' }}>
                                <TableHead>
                                    <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                                        <StyledTableCell>SR.</StyledTableCell>
                                        <StyledTableCell>
                                            <Typography fontFamily={"Satoshi-Bold"} width={"100px"} whiteSpace={"wrap"}>
                                                Purchase Entry Number
                                            </Typography>
                                        </StyledTableCell>
                                        <StyledTableCell>Vendor Name</StyledTableCell>
                                        <StyledTableCell>Po Number</StyledTableCell>
                                        <StyledTableCell>Invoice Number</StyledTableCell>
                                        <StyledTableCell>Delivery Date</StyledTableCell>
                                        <StyledTableCell>Quantity</StyledTableCell>
                                        <StyledTableCell>Amount</StyledTableCell>
                                        <StyledTableCell>Action</StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                               
                                    {importData?.length > 0 ?
                                        importData?.map((row, index) => {
                                            return (
                                                <React.Fragment key={index}>
                                                    <StyledTableRow>
                                                        <StyledTableCell> {index + 1 + (page - 1) * PerPage}</StyledTableCell>
                                                        <StyledTableCell> {row?.purchaseEntryNumber ? row?.purchaseEntryNumber : "NA"}</StyledTableCell>
                                                        <StyledTableCell> {row?.vendorName ? row?.vendorName : "NA"}</StyledTableCell>
                                                        <StyledTableCell> {row?.poNumber ? row?.poNumber : "0"}</StyledTableCell>
                                                        <StyledTableCell> {row?.invoiceNumber ? row?.invoiceNumber : "0"}</StyledTableCell>
                                                        <StyledTableCell>
                                                            {row?.deliveryDate ? new Date(row.deliveryDate).toLocaleDateString() : ""}
                                                        </StyledTableCell>
                                                        <StyledTableCell> {row?.totalSupplyQuantity ? row?.totalSupplyQuantity : "0"}</StyledTableCell>
                                                        <StyledTableCell> {row?.totalSupplyAmount ? row?.totalSupplyAmount : "0"}</StyledTableCell>
                                                        <StyledTableCell> {
                                                            <Fab
                                                                sx={{
                                                                    height: '36px',
                                                                    width: '36px',
                                                                    minHeight: "30px",
                                                                    backgroundColor: theme.palette.primary.main,
                                                                    boxShadow: "none",
                                                                    "&.MuiFab-root.Mui-disabled": {
                                                                        backgroundColor: 'transparent'
                                                                    },
                                                                    "&:hover": { backgroundColor: theme.palette.primary.main },
                                                                }}
                                                                onClick={() => {
                                                                    const isOpening = index !== openRow; // true if opening this row
                                                                    setOpenRow(isOpening ? index : null);

                                                                    if (isOpening) {
                                                                        _getSubData(index); // fetch or set subData when opening
                                                                    } else {
                                                                        setSubData([]); // clear subData when closing
                                                                    }
                                                                }}
                                                            >
                                                                {openRow === index ? <KeyboardArrowUpIcon sx={{ color: "#FFF" }} /> : <KeyboardArrowDownIcon sx={{ color: "#FFF" }} />}
                                                            </Fab>}
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={12} style={{ padding: "0px 10px 0px 10px" }}>
                                                            <Collapse in={openRow === index} timeout="auto" unmountOnExit>
                                                                <Box margin={1}>
                                                                    <Typography fontSize={'18px'} fontFamily={"Satoshi-Bold"} ml={1} mb={1}>
                                                                        All Items
                                                                    </Typography>

                                                                    <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                                                                        <TableContainer>
                                                                            <Table>
                                                                                <TableHead>
                                                                                    <StyledTableRow isHeader>
                                                                                        <StyledTableCell>SR.</StyledTableCell>
                                                                                        <StyledTableCell>Item Name</StyledTableCell>
                                                                                        <StyledTableCell>Advance Licenese Price</StyledTableCell>
                                                                                        <StyledTableCell>Advance Licenese Quantity</StyledTableCell>
                                                                                        <StyledTableCell>Rate Per Unit</StyledTableCell>

                                                                                    </StyledTableRow>
                                                                                </TableHead>

                                                                                <TableBody>
                                                                                    {paginatedSubData?.length > 0 ? (
                                                                                        paginatedSubData.map((subRow, subIndex) => (
                                                                                            <StyledTableRow key={subIndex}>
                                                                                                <StyledTableCell>{subIndex + 1 + (subPage - 1) * SubPerPage}</StyledTableCell>
                                                                                                <StyledTableCell>
                                                                                                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                                                                        <Box backgroundColor="#F7FAFC" sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "11px 10px", width: "fit-content", textAlign: "center" }}>
                                                                                                            <Typography fontFamily={"Satoshi-Medium"} fontSize={'12px'} noWrap>{subRow.itemName || "NA"}</Typography>
                                                                                                        </Box>
                                                                                                    </Box>
                                                                                                </StyledTableCell>
                                                                                                <StyledTableCell>{subRow.advanceLicenesePrice || "NA"}</StyledTableCell>
                                                                                                <StyledTableCell>{subRow.advanceLiceneseQuantity || "NA"}</StyledTableCell>
                                                                                                <StyledTableCell>{Number(subRow.ratePerUnit).toFixed(3) || "NA"}</StyledTableCell>
                                                                                            </StyledTableRow>
                                                                                        ))
                                                                                    ) : (
                                                                                        <StyledTableRow>
                                                                                            <StyledTableCell colSpan={13}>
                                                                                                <NoDataFound />
                                                                                            </StyledTableCell>
                                                                                        </StyledTableRow>
                                                                                    )}
                                                                                </TableBody>
                                                                            </Table>
                                                                        </TableContainer>

                                                                        <CommonPagination
                                                                            totalCount={subData.length}
                                                                            count={Math.ceil(subData.length / SubPerPage)}
                                                                            itemsPerPage={SubPerPage}
                                                                            page={subPage}
                                                                            onChange={handleChangeSubPage}
                                                                        />
                                                                    </Box>
                                                                </Box>
                                                            </Collapse>
                                                        </StyledTableCell>
                                                    </StyledTableRow>


                                                </React.Fragment>
                                            )
                                        })
                                        :
                                        <StyledTableRow>
                                            <StyledTableCell colSpan={12}>
                                                <NoDataFound />
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <CommonPagination
                            totalCount={itotalCount}
                            count={Math.ceil(itotalCount / PerPage)}
                            itemsPerPage={PerPage}
                            page={page}
                            onChange={handleChangeIPage}
                        />
                    </Box>
                </Grid>
            }
        </Grid>
    )
}

export default ViewDocument